import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-scene-block-base-padding',
    templateUrl: './block-base-padding.component.html',
    styleUrls: ['./block-base-padding.component.scss'],
    standalone: false
})
export class BlockBasePaddingComponent extends BlockBaseComponent {

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog
    ) {
        super(storeSelector, dialog);
    }

    
    override componentInit() {
        super.componentInit();
    }
    
    override componentStoreUpdates() {
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }
    
    override submit(formValues) {
        return super.submit(formValues);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: "0",
                label: "top",
                inputType: "number_rich",
                showManualInput: true,
                min: 0,
                max: 100,
                step: 10,
                name: "top",
                storePath: "Data[0].Padding[0].$.top",
            },
            {
                type: "input",
                value: "0",
                label: "left",
                inputType: "number_rich",
                showManualInput: true,
                min: 0,
                max: 100,
                step: 10,
                name: "left",
                storePath: "Data[0].Padding[0].$.left",
            },
            {
                type: "input",
                value: "0",
                label: "right",
                inputType: "number_rich",
                showManualInput: true,
                min: 0,
                max: 100,
                step: 10,
                name: "right",
                storePath: "Data[0].Padding[0].$.right",
            },
            {
                type: "input",
                value: "0",
                label: "bottom",
                inputType: "number_rich",
                showManualInput: true,
                min: 0,
                max: 100,
                step: 10,
                name: "bottom",
                storePath: "Data[0].Padding[0].$.bottom",
            },
        ];
    }
}

